import { getAggregationCategory } from '@components/music/filter/utils/helpers'
import { AggregationTerm, Difficulty } from '@components/music/filter/utils/types'

const DIFFICULTY_URLS = {
  [Difficulty.BEGINNER]: 'beginner',
  [Difficulty.INTERMEDIATE]: 'intermediate',
  [Difficulty.ADVANCED]: 'advanced',
}

const DURATION_URLS = {
  '0.01-180.0': 'less-than-3-min',
  '180.0-300.0': '3-to-5-min',
  '300.0-600.0': '5-to-10-min',
  '600.0-*': 'over-10-min',
}

const SPECIAL_URLS: { [key in AggregationTerm]?: (term: string) => string } = {
  [AggregationTerm.DIFFICULTY]: (term: string) => DIFFICULTY_URLS[term] ?? term,
  [AggregationTerm.DURATION]: (term: string) => DURATION_URLS[term] ?? term,

  /** Takes a term like "Ab/Major" into "key-ab-major" */
  [AggregationTerm.OPENING_KEY]: (term: string) => {
    const [note, mode] = term.toLowerCase().split('/')
    const [letter, accidental] = note
    let value = letter
    if (accidental === '#') value += '-sharp'
    else if (accidental === 'b') value += '-flat'

    return `key-${value}-${mode}`
  },

  [AggregationTerm.MUSIC_SOURCE]: (term: string) =>
    term.toLowerCase().replace(/\s/g, (match, offset) => {
      // Remove spaces before numbers
      if (offset < term.length - 1 && term[offset + 1].match(/[0-9]/g)) return ''

      // All other spaces should be turned into hyphens
      return '-'
    }),
}

export function urlFromFacet(category: string, term: string): string {
  const aggCategory = getAggregationCategory(category)
  if (SPECIAL_URLS[aggCategory]) return SPECIAL_URLS[aggCategory](term)
  return underscoreToHyphen(camelToHyphen(removeSpaces(term)))
}

function removeSpaces(str: string): string {
  return str.replace(/\s/g, '')
}

function camelToHyphen(str: string): string {
  return str.replace(/[A-Z]/g, (match, offset) => (offset > 0 ? '-' : '') + match.toLowerCase())
}

function underscoreToHyphen(str: string): string {
  return str.replace(/_/g, '-')
}
